import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";
import { getColumnIntoKey } from "~pages/PriceSearchV2/utils/initializerHelpers";

const usePesquisaMedida = (formikRef, trilhaCodigo, embalagemId, pesquisaGrupoMaterialId = 0) => {
  const pesquisaMedidaSelect = useSelect("pesquisaMedida");
  const [pesquisaMedida, setPesquisaMedida] = useState(0);
  const [pesquisaMedidaObjeto, setPesquisaMedidaObjeto] = useState({});
  const [primeiraAtualizacao, setPrimeiraAtualizacao] = useState(true);
  const [fila, setFila] = useState(null);

  const [pesquisaMedidasSelectEnabled, setPesquisaMedidasSelectEnabled] = useState(true);

  const [pesquisaMedidas, setPesquisaMedidas] = useState([]);
  const [pesquisaGrupoMaterialUnidadeMedidas, setPesquisaGrupoMaterialUnidadeMedidas] = useState([]);

  useEffect(() => {
    const fetchPesquisaMedidas = async () => {
      const medidas = [];
      await db.pesquisaMedidas.each((medida) => {
        medidas.push(medida);
      });
      setPesquisaMedidas(medidas);
    };

    const fetchPesquisaGrupoMaterialUnidadeMedidas = async () => {
      const grupoMaterialUnidadeMedidas = [];
      await db.pesquisaGrupoMaterialUnidadeMedida.each((grupo) => {
        grupoMaterialUnidadeMedidas.push(grupo);
      });
      setPesquisaGrupoMaterialUnidadeMedidas(grupoMaterialUnidadeMedidas);
    };

    fetchPesquisaMedidas();
    fetchPesquisaGrupoMaterialUnidadeMedidas();
  }, []);

  const pesquisaGrupoMaterialUnidadeMedidaMemo = useMemo(() => {
    if (pesquisaGrupoMaterialUnidadeMedidas?.length) {
      return pesquisaGrupoMaterialUnidadeMedidas.reduce((acc, e) => {
        acc[`${e.pesquisaGrupoMaterialId}/${e.pesquisaUnidadeMedidaId}`] = true;
        return acc;
      }, {});
    }
    return {};
  }, [pesquisaGrupoMaterialUnidadeMedidas]);

  const optionPesquisaMedida = useMemo(() => {
    if (!primeiraAtualizacao) {
      onChangePesquisaMedida("");
    }

    let temp = [];

    //  TAC
    if (trilhaCodigo == "400") {
      setPrimeiraAtualizacao(false);
      temp = pesquisaMedidas?.filter((e) => e.nome == "unidades");

      //  GRANEL
      if (embalagemId && embalagemId != 0 && embalagemId == 237)
        temp = pesquisaMedidas?.filter((e) => e.nome == "toneladas");

      if (temp?.length > 0) {
        onChangePesquisaMedida({ label: temp[0].nome, value: temp[0].id });
        toggleEnablePesquisaMedida(false);
      }
    }
    //  IND
    else if (trilhaCodigo == "420") {
      setPrimeiraAtualizacao(false);
      temp = pesquisaMedidas?.filter((e) => e.nome == "toneladas");

      if (temp?.length > 0) {
        onChangePesquisaMedida({ label: temp[0].nome, value: temp[0].id });
        toggleEnablePesquisaMedida(false);
      }
    } else {
      if (pesquisaGrupoMaterialId && pesquisaGrupoMaterialId != 0) {
        setPrimeiraAtualizacao(false);
        temp = (pesquisaMedidas || []).filter(
          (e) =>
            Object.entries(pesquisaGrupoMaterialUnidadeMedidaMemo).length > 0 &&
            pesquisaGrupoMaterialUnidadeMedidaMemo[pesquisaGrupoMaterialId + "/" + e.id]
        );
        toggleEnablePesquisaMedida(true);
      }
    }

    if (pesquisaMedidas?.length > 0) {
      setPesquisaMedidaObjeto(getColumnIntoKey({ data: pesquisaMedidas, prefix: "id-" }));
    }

    return prepareForOptions(temp, ["nome"], "id");
  }, [pesquisaMedidas, pesquisaGrupoMaterialId, trilhaCodigo, embalagemId]);

  //PESQUISA-GRUPO-MATERIAL-UNIDADE-MEDIDA

  useEffect(() => {
    if (
      fila &&
      pesquisaGrupoMaterialUnidadeMedidaMemo &&
      Object.keys(pesquisaGrupoMaterialUnidadeMedidaMemo).length > 0 &&
      pesquisaMedidas &&
      pesquisaMedidas.length > 0
    ) {
      setPesquisaMedidaSelect(fila);
    }
  }, [fila, pesquisaMedidas, pesquisaGrupoMaterialUnidadeMedidaMemo]);

  function setPesquisaMedidaSelect(value) {
    if (
      pesquisaGrupoMaterialUnidadeMedidaMemo &&
      Object.keys(pesquisaGrupoMaterialUnidadeMedidaMemo).length > 0 &&
      pesquisaMedidas &&
      pesquisaMedidas.length > 0
    ) {
      const optionMedida = (pesquisaMedidas || []).find((optMedida) => optMedida.id == value);

      if (optionMedida) {
        onChangePesquisaMedida({
          label: optionMedida.nome,
          value: optionMedida.id,
        });
      }
      setFila(null);
    } else {
      setFila(value);
    }
  }

  function onChangePesquisaMedida(e) {
    pesquisaMedidaSelect.upDateValue(e.value);
    pesquisaMedidaSelect.upDateDefaultValue(e || "");
    const formikInstance = formikRef?.current;
    if (formikInstance) {
      formikInstance.setFieldValue("unidadeMedidaId", e.value);
      setTimeout(() => formikInstance.setFieldTouched("unidadeMedidaId", true));
    }
  }

  function toggleEnablePesquisaMedida(enabled = true) {
    setPesquisaMedidasSelectEnabled(enabled);
  }

  return {
    pesquisaMedidaObjeto,
    pesquisaMedidas,
    optionPesquisaMedida,
    onChangePesquisaMedida,
    pesquisaMedida,
    pesquisaMedidaSelect,
    setPesquisaMedida,
    setPesquisaMedidaSelect,
    pesquisaMedidasSelectEnabled,
  };
};

export default usePesquisaMedida;
